module.exports = __webpack_public_path__ + "static/media/heroku.3d790268.png";